import VaspsTable from './VaspsTable'

export default VaspsTable
